import { AuthRouteImport } from './Import'
import PageNotFound from './PageNotFound'
const { RoutesMap, UserLogin, StudentLogin } = AuthRouteImport

const AuthRoute = () => {
    return [
        {
            path: RoutesMap.LOGIN.path,
            element: <UserLogin />
        },
        {
            path: RoutesMap.STUDENT_LOGIN.path,
            element: <StudentLogin />
        },
        {
            path: RoutesMap.UNKNOWN_PATH.path,
            element: <PageNotFound />
        },
    ]
}

export default AuthRoute;